import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { AutocompleteFilterOpts, FilterOpts, MinMax } from "@saleor/types";
import { CouponStatusEnum } from "@saleor/types/globalTypes";
import {
  createAutocompleteField,
  createBooleanField,
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum CouponFilterKeys {
  couponFeatured = "couponFeatured",
  status = "status",
  effectivityDates = "effectivityDates",
  mall = "mall"
}

export interface CouponListUrlFilterOpts {
  couponFeatured: FilterOpts<boolean>;
  status: FilterOpts<CouponStatusEnum[]>;
  effectivityDates: FilterOpts<MinMax>;
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "Active Coupon"
  },
  completed: {
    defaultMessage: "Completed",
    description: "Completed Coupon"
  },
  couponFeatured: {
    defaultMessage: "Featured",
    description: "Featured Coupon"
  },
  editing: {
    defaultMessage: "Editing",
    description: "Drafted coupon"
  },
  effectivityDates: {
    defaultMessage: "Effectivity Dates",
    description: "Effectivity Dates"
  },
  expired: {
    defaultMessage: "Expired",
    description: "expired coupon"
  },
  inactive: {
    defaultMessage: "Inactive",
    description: "Inactive coupon"
  },
  scheduled: {
    defaultMessage: "Scheduled",
    description: "Scheduled coupon"
  },
  status: {
    defaultMessage: "Status",
    description: "Coupon Status"
  },
  mall: {
    defaultMessage: "Mall",
    description: "mall Name"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CouponListUrlFilterOpts
): IFilter<CouponFilterKeys> {
  return [
    {
      ...createBooleanField(
        CouponFilterKeys.couponFeatured,
        intl.formatMessage(messages.couponFeatured),
        opts.couponFeatured.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.couponFeatured.active
    },
    {
      ...createOptionsField(
        CouponFilterKeys.status,
        intl.formatMessage(messages.status),
        opts.status.value,
        true,
        [
          {
            label: intl.formatMessage(messages.active),
            value: CouponStatusEnum.ACTIVE
          },
          {
            label: intl.formatMessage(messages.completed),
            value: CouponStatusEnum.COMPLETED
          },
          {
            label: intl.formatMessage(messages.editing),
            value: CouponStatusEnum.DRAFT
          },
          {
            label: intl.formatMessage(messages.expired),
            value: CouponStatusEnum.EXPIRED
          },
          {
            label: intl.formatMessage(messages.inactive),
            value: CouponStatusEnum.INACTIVE
          },
          {
            label: intl.formatMessage(messages.scheduled),
            value: CouponStatusEnum.SCHEDULED
          }
        ]
      ),
      active: opts.status.active
    },
    {
      ...createDateField(
        CouponFilterKeys.effectivityDates,
        intl.formatMessage(messages.effectivityDates),
        opts.effectivityDates.value
      ),
      active: opts.effectivityDates.active
    },
    {
      ...createAutocompleteField(
        CouponFilterKeys.mall,
        intl.formatMessage(messages.mall),
        opts.mall.value,
        opts.mall.displayValues,
        true,
        opts.mall.choices,
        {
          hasMore: opts.mall.hasMore,
          initialSearch: "",
          loading: opts.mall.loading,
          onFetchMore: opts.mall.onFetchMore,
          onSearchChange: opts.mall.onSearchChange
        }
      ),
      active: opts.mall.active
    }
  ];
}
